import React, { useEffect, useState } from 'react';
import './ReachIisc.css';
import Navbar from './Navbar';
import Footer from './Footer';

const ReachIisc = () => {
  const [activeAirportTab, setActiveAirportTab] = useState('shuttle');
  const [activeStation, setActiveStation] = useState('mainStation');
  const [selectedTerminal, setSelectedTerminal] = useState('terminal1');
  const [selectedRoute, setSelectedRoute] = useState('t1-ola');
  const [imageError, setImageError] = useState(false);

  // Helper function to get the correct asset path
  // Matching the pattern used in other components (HomePage.jsx, About.js, etc.)
  const getAssetPath = (path) => {
    return `/stis2025${path}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const airportTabs = {
    shuttle: {
      title: 'KSTDC Bus (Shuttle)',
      heading: 'Airport Shuttle Service',
      info: [
        'Frequent AC Flybus service from Kempegowda International Airport (BIAL)',
        'Available 24/7 at 30-minute intervals',
        'Disembark at Mekhri Circle and take an auto/taxi (~2 km to IISc)',
        'Fare: ₹250–300 per person',
        'Online booking available on BMTC/ViaWorld portals',
        'Airport helpline: +91-80-4058-1111 | Booking: www.viaworld.in'
      ],
      link: 'https://www.bengaluruairport.com/transport/flybus.html'
    },
    taxi: {
      title: 'Prepaid Airport Taxis',
      heading: 'Official Airport Taxi Service',
      info: [
        'Available at prepaid counters near the arrival area',
        'Multiple operators: Meru, Mega Cabs, KSTDC etc.',
        'Travel Time: 60–90 mins | Distance: 35 km',
        'Fare: ₹800–1000 (fixed rates)',
        'Premium taxis & AC options available',
        'Taxi Services: SGL (+91-80-4299-4399), Akbar (+91-1800-226-000)'
      ],
      link: 'https://www.bengaluruairport.com/transport/taxi.html'
    },
    rideshare: {
      title: 'Ride-Sharing (Uber/Ola)',
      heading: 'App-Based Cab Services',
      info: [
        'Pickup from designated Ride Zones (follow airport signs)',
        'Affordable with live GPS tracking',
        'Payment via app (cash/card/UPI)',
        'Fare: ₹700–900 depending on traffic',
        'EasyCab: +91-94105-61625 | Support: In-app'
      ],
      link: 'https://www.bengaluruairport.com/transport/ride-hailing.html'
    }
  };

  const stationTabs = {
    mainStation: {
      title: 'Bengaluru City Railway Station',
      distance: '7 km',
      details: [
        'Prepaid auto available at the exit',
        'BMTC Bus Routes: 252E, 258C, 271E, 273C, 275, 276, 99A/B',
        'Bus stop: Tata Institute (IISc)'
      ]
    },
    cantonmentStation: {
      title: 'Cantonment Railway Station',
      distance: '7 km',
      details: [
        'Prepaid autos and city buses available',
        'BMTC Routes: 94A/E, 252A, 270A, 272, 276A'
      ]
    },
    yeshwantpurStation: {
      title: 'Yeshwantpur Railway Station',
      distance: '3 km',
      details: [
        'Nearest station to IISc',
        'Auto and BMTC buses available',
        'Limited train halts – check schedule before booking'
      ]
    }
  };

  const transportOptions = [
    {
      mode: 'Taxi',
      points: [
        'Say "Tata Institute" to the driver',
        'Available across city and airport',
        'Recommended apps: Uber, Ola',
        'Fare: ₹15/km + ₹60/hour wait time',
        'Reliable providers: ',
        'Meru (+91-80-4422-4422), CelCabs (+91-80-6060-9090)'
      ]
    },
    {
      mode: 'Auto Rickshaw',
      points: [
        'Confirm meter usage or fix fare in advance',
        'Inexpensive for short distances',
        'Ola Auto/Uber Auto options available'
      ]
    },
    {
      mode: 'BMTC Bus',
      points: [
        'Say "Tata Institute" to conductor',
        'Multiple buses from all major junctions',
        'Fare: ₹20–40 depending on route',
        'Enquiry: BMTC Control Room (+91-80-2295-2522)'
      ]
    }
  ];

  // Airport terminal routes configuration
  const terminalRoutes = {
    terminal1: {
      routes: [
        { id: 't1-ola', label: 'Terminal 1 to Ola', image: getAssetPath('/assets/airport-maps/t1-ola.jpg') },
        { id: 't1-uber', label: 'Terminal 1 to Uber', image: getAssetPath('/assets/airport-maps/t1-uber.jpg') },
        { id: 't1-bus', label: 'Terminal 1 to Bus Stand', image: getAssetPath('/assets/airport-maps/t1-bus.jpg') }
      ]
    },
    terminal2: {
      routes: [
        { id: 't2-taxi-ola', label: 'Terminal 2 to Ola/Uber/Others', image: getAssetPath('/assets/airport-maps/t2-taxi-ola.jpg'), directions: [
          'Walk straight for 27 meters',
          'Turn slightly right',
          'Walk straight for 110 meters',
          'Turn left',
          'Walk straight for 63 meters'
           ]},
        { id: 't2-airport-taxi', label: 'Terminal 2 to Airport Taxi', image: getAssetPath('/assets/airport-maps/taxi.JPG'), boardImage: getAssetPath('/assets/airport-maps/board.jpg'), directions: [
          'After exiting the gate, look for the Airport Taxi board (see image below)',
          'Walk straight for 27 meters',
          'Turn left',
          'Walk straight for 31 meters',
          'Turn right. Walk past Nandini',
          'Walk straight past Chayoos',
          'Walk straight past Smoor',
          'Turn left. Walk past Maiyas'
        ] },
        { id: 't2-cash1', label: 'Terminal 2 to Cash Exchange 1', image: getAssetPath('/assets/airport-maps/t2-cash1.jpg') },
        { id: 't2-cash2', label: 'Terminal 2 to Cash Exchange 2', image: getAssetPath('/assets/airport-maps/t1-cash2.jpg') }
      ]
    }
  };

  return (
    <>
        <Navbar />
    <div className="reach-iisc-container">
      <h1 className="page-title">How to Reach IISc, Bengaluru</h1>
      <p className="tagline">A comprehensive travel guide for our conference delegates</p>

      <section className="info-section highlight-box">
        <h2>Quick Facts</h2>
        <ul>
          <li><strong>IISc is locally referred to as:</strong> Tata Institute</li>
          <li><strong>Distance from Airport:</strong> 35 km (60–90 minutes by road)</li>
          <li><strong>City Code for landlines:</strong> +91-80</li>
        </ul>
      </section>

      <section className="airport-maps-section">
        <h2>Airport Terminal Navigation Maps</h2>
        
        {/* International Delegates Notice */}
        <div className="international-notice">
          <div className="notice-icon">💡</div>
          <div className="notice-content">
            <h3>Important Information for International Delegates</h3>
            <p>
              <strong>Please bring cash from your respective country</strong> to exchange at the airport. 
              Cash exchange counters are available at both terminals. Detailed maps with highlighted paths 
              are available below to help you navigate to transport services and currency exchange counters.

              {/* <strong>Please check your terminal in your ticket<strong/> */}
              
            </p>

            <strong>Please check your terminal in your ticket/boarding pass.</strong>
          </div>
        </div>

        {/* Terminal Selection */}
        <div className="terminal-selection">
          <h3>Select Your Terminal</h3>
          <div className="terminal-buttons">
            <button
              className={`terminal-btn ${selectedTerminal === 'terminal1' ? 'active' : ''}`}
              onClick={() => {
                setSelectedTerminal('terminal1');
                setSelectedRoute('t1-ola');
                setImageError(false);
              }}
            >
              Terminal 1 (T1)
            </button>
            <button
              className={`terminal-btn ${selectedTerminal === 'terminal2' ? 'active' : ''}`}
              onClick={() => {
                setSelectedTerminal('terminal2');
                setSelectedRoute('t2-taxi-ola');
                setImageError(false);
              }}
            >
              Terminal 2 (T2)
            </button>
          </div>
        </div>

        {/* Route Selection */}
        <div className="route-selection">
          <h3>Select Route/Service</h3>
          <div className="route-buttons">
            {terminalRoutes[selectedTerminal].routes.map((route) => (
              <button
                key={route.id}
                className={`route-btn ${selectedRoute === route.id ? 'active' : ''}`}
                onClick={() => {
                  setSelectedRoute(route.id);
                  setImageError(false);
                }}
              >
                {route.label}
              </button>
            ))}
          </div>
        </div>

        {/* Map Display */}
        {selectedRoute && (
          <div className="map-display-container">
            <div className="map-display">
              {!imageError ? (
                <img
                  src={terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.image}
                  alt={terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.label}
                  className="terminal-map-image"
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    // Try fallback path for development mode
                    const currentSrc = e.target.src;
                    if (currentSrc.includes('/stis2025/') && !imageError) {
                      const fallbackSrc = currentSrc.replace('/stis2025', '');
                      console.log('Trying fallback path:', fallbackSrc);
                      e.target.src = fallbackSrc;
                      // Set error after a brief delay if fallback also fails
                      const timeoutId = setTimeout(() => {
                        if (e.target.complete && e.target.naturalWidth === 0) {
                          setImageError(true);
                        }
                      }, 500);
                      e.target.onload = () => {
                        clearTimeout(timeoutId);
                        setImageError(false);
                      };
                    } else {
                      setImageError(true);
                    }
                  }}
                />
              ) : (
                <div className="map-error-message">
                  <p>⚠️ Map image not available</p>
                  <p>Please check that the image file is placed in the correct location.</p>
                  <p><small>Expected: {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.image}</small></p>
                  <p><small>Also tried: {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.image?.replace('/stis2025', '')}</small></p>
                </div>
              )}
              <div className="map-caption">
                {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.label}
              </div>
            </div>
            
            {/* Directions Display */}
            {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.directions && (
              <div className="directions-display">
                <div className="directions-content">
                  <h4>Directions (Terminal 2, Exit Gate 1 to Airport Taxi)</h4>
                  <ol className="directions-list">
                    {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.directions.map((direction, idx) => (
                      <li key={idx}>{direction}</li>
                    ))}
                  </ol>
                </div>
                {/* Show board image if available (for Terminal 2 to Airport Taxi) */}
                {terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.boardImage && (
                  <div className="board-image-container">
                    <p className="board-image-label">Look for this board for Airport Taxi</p>
                    <img
                      src={terminalRoutes[selectedTerminal].routes.find(r => r.id === selectedRoute)?.boardImage}
                      alt="Airport Taxi Board"
                      className="board-image"
                      onError={(e) => {
                        console.error('Board image failed to load:', e.target.src);
                        const currentSrc = e.target.src;
                        if (currentSrc.includes('/stis2025/')) {
                          e.target.src = currentSrc.replace('/stis2025', '');
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Instructions */}
        <div className="map-instructions">
          <h4>How to Use These Maps</h4>
          <ul>
            <li>Select your arrival terminal (T1 or T2)</li>
            <li>Choose the service or location you need to reach</li>
            <li>Follow the highlighted path on the map</li>
            <li>Maps show the exact route from your terminal to the destination</li>
          </ul>
        </div>
      </section>

      <section className="airport-section">
        <h2>Traveling from Bengaluru International Airport (BIAL)</h2>
        <div className="airport-tabs">
          {Object.keys(airportTabs).map((key) => (
            <button
              key={key}
              className={`airport-tab ${activeAirportTab === key ? 'active' : ''}`}
              onClick={() => setActiveAirportTab(key)}
            >
              {airportTabs[key].title}
            </button>
          ))}
        </div>
        <div className="airport-details">
          <h3>{airportTabs[activeAirportTab].heading}</h3>
          <ul>
            {airportTabs[activeAirportTab].info.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <a
            href={airportTabs[activeAirportTab].link}
            target="_blank"
            rel="noopener noreferrer"
            className="external-link"
          >
            Learn more →
          </a>
        </div>
      </section>

      {/* Airport Terminal Maps Section */}
      

      <section className="transport-section">
        <h2>Local Transport Options</h2>
        <div className="transport-cards">
          {transportOptions.map((option, index) => (
            <div className="transport-card" key={index}>
              <h4>{option.mode}</h4>
              <ul>
                {option.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="railway-section">
        <h2>Reaching via Train</h2>
        <div className="railway-tabs">
          {Object.keys(stationTabs).map((key) => (
            <button
              key={key}
              className={`station-tab ${activeStation === key ? 'active' : ''}`}
              onClick={() => setActiveStation(key)}
            >
              {stationTabs[key].title}
            </button>
          ))}
        </div>
        <div className="station-details">
          <h4>{stationTabs[activeStation].title} <span>({stationTabs[activeStation].distance})</span></h4>
          <ul>
            {stationTabs[activeStation].details.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="map-section">
        <h2>Campus Location</h2>
        <p>IISc is situated in central Bengaluru and is easily accessible from all parts of the city.</p>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15553.867420936048!2d77.5652489!3d13.0148257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae166b2e68f1a3%3A0x8583c93d79113b6f!2sIndian%20Institute%20of%20Science!5e0!3m2!1sen!2sin!4v1693847769244!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: "0", borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
            title="IISc Campus Location"
          ></iframe>
        </div>
        <button
          className="directions-button"
          onClick={() =>
            window.open('https://www.google.com/maps/dir/?api=1&destination=Indian+Institute+of+Science,+Bengaluru', '_blank')
          }
        >
          Get Directions
        </button>
      </section>
    </div>
    <br />
    <br />
    <Footer />
    </>
  );
};

export default ReachIisc;
